import React from "react"
import MoneyBackBadge from "./money-back.png"

const MoneyBackGuarantee = () => {
  return (
    <div className="w-full bg-[#f4f5ff] py-12 px-4 sm:px-12">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-10 max-w-7xl mx-auto text-center sm:text-left">
        <div className="flex-shrink-0 flex justify-center sm:justify-start">
          <img
            src={MoneyBackBadge}
            alt="30-day money-back guarantee badge"
            className="w-[200px] sm:w-[280px] h-auto"
          />
        </div>
        <div className="flex flex-col justify-center max-w-2xl">
          <h3 className="text-[28px] sm:text-[36px] font-bold font-['Beausite Classic'] text-black mb-4 text-center">
            Zero Risk. Full Confidence.
          </h3>
          <p className="text-gray-800 text-lg leading-relaxed text-center">
            Try Zoee completely risk-free with our 30-day money-back guarantee.
            If it’s not the right fit, just email us within 30 days and we’ll
            refund you in full — no awkward conversations, no hassle. You can
            also cancel anytime directly in your account.
          </p>
        </div>
      </div>
    </div>
  )
}

export default MoneyBackGuarantee
